import { styled, Typography } from '@mui/material'

export const ResponsiveTypography = styled(Typography)({
  fontSize: '2rem',
  fontWeight: '700',

  '@media (min-width:600px)': {
    fontSize: '1.5rem',
  },
})
